import React from "react";
import "../Company/About.css";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t, i18n } = useTranslation();

  // 현재 언어 가져오기
  const currentLanguage = i18n.language;
  return (
    <div className="sub-wrap">
      <div className="inner_page_title">About</div>
      <div className="content">
        <div className="About-box">
          <div className={`About-image ${currentLanguage}`}></div>
          <div className="About-txt">
            <div className="txt-1">
              <div className="txt-number">1 </div>
              <div className="txt">
                <span>{t("about.about01")}</span>
                {t("about.about01-1")}
              </div>
            </div>
            <div className="txt-1">
              <div className="txt-number">2 </div>
              <div className="txt">
                <span>{t("about.about02")}</span>
                {t("about.about02-1")}
              </div>
            </div>
            <div className="txt-1">
              <div className="txt-number">3 </div>
              <div className="txt">
                <span>{t("about.about03")}</span>
                {t("about.about03-1")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
